import { TriageFilterProvider } from "admin/components/diagnostics/TriageFilterContext";
import { TriageTable } from "admin/components/diagnostics/TriageTable";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { NEXTGEN_MAX_CONTENT_WIDTH } from "~/lib/layout";

export const TurnDiagnostics = () => {
  useDocumentTitle("Turn Diagnostics");

  // N.B. Heading and padding follow the Admin sidebar's other pages (Users,
  // Groups) rather than this page's earlier compact layout: the nav pill now
  // reads "Admin" for every page in the section, so each one has to name
  // itself.
  return (
    <div
      className="flex w-full flex-col space-y-6 p-6"
      style={{ maxWidth: NEXTGEN_MAX_CONTENT_WIDTH, margin: "0 auto" }}
    >
      <div className="space-y-1">
        <h1 className="text-3xl font-bold text-foreground">Turn Diagnostics</h1>
        <p className="text-muted-foreground text-lg">
          Triage the quality of individual agent turns
        </p>
      </div>
      <TriageFilterProvider>
        {/* Rubric dimensions come from the diagnostics summary endpoint, which the backend
            doesn't implement yet, so the detail drawer falls back to raw dimension names. */}
        <TriageTable rubricDimensions={[]} />
      </TriageFilterProvider>
    </div>
  );
};
